"use client";

import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Buttons from "./Buttons";
import CloseIcon from "@mui/icons-material/Close";
import { ClipShareWithDetails } from "@/api/bookmarkClipShares";

function ShareButtonWithData({
  clipShareData,
  transcriptText,
}: {
  clipShareData: ClipShareWithDetails;
  transcriptText: string;
}) {

const getShareLink = (
  clipData?: ClipShareWithDetails,
  meetingId?: number,
  originalSearchParams?: URLSearchParams,
): string => {
  if (!clipData?.id) {
    return "";
  }
  const searchParams = new URLSearchParams(originalSearchParams);

  if (clipData.transcript_doc_id) {
    searchParams.set("type", "clip");
    searchParams.set("transcript_id", clipData.transcript_doc_id.toString());

    return `${window.location.origin}/share/${clipData.id}?${searchParams.toString()}`;
  } else if (meetingId) {
    // Fallback to meeting share if no transcript_id
    return `${window.location.origin}/share/${meetingId}`;
  }

  return "";
}; 

  return (
    <Buttons
      transcriptText={transcriptText}
      meetingTitle={clipShareData.meeting.title}
      organizationName={clipShareData.organization.name}
      shareLink={getShareLink(clipShareData, clipShareData.meeting.id, new URLSearchParams())}
    />
  );
}

export default function ShareButtonClient({
  clipShareData,
  transcriptText,
  handleClose,
}: {
  clipShareData: ClipShareWithDetails;
  transcriptText: string;
  handleClose: () => void;
}) {
  return (

    <Dialog open onClose={handleClose} fullWidth>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle variant="h5">Share</DialogTitle>
      <DialogContent>
        <ShareButtonWithData
          transcriptText={transcriptText}
          clipShareData={clipShareData}
        />
      </DialogContent>
  </Dialog>
  );
}